module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/entities/profile/profile-tab/profile-tab.component.scss
// module id = ./src/app/entities/profile/profile-tab/profile-tab.component.scss
// module chunks = main